import { ExpandableSection, ExpandableSectionProps } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { Quote } from '../../../domain'
import { useExcesses } from '../../../hooks/excess'
import { useProduct } from '../../product/ProductProvider'
import { ExcessSummary } from './ExcessSummary'

export interface ExcessExpandableProps extends ExpandableSectionProps {
  quote: Quote
}

export const ExcessExpandable: FunctionComponent<ExcessExpandableProps> = ({
  quote,
  header,
  ...props
}) => {
  const {
    product: { excesses },
  } = useProduct()

  const { main, other, voluntary, applicable } = useExcesses(quote)

  const hasExcesses = [main, other, voluntary, applicable].some((it) => it.length > 0)

  return excesses && hasExcesses ? (
    <ExpandableSection header={header} {...props}>
      <ExcessSummary quote={quote} />
    </ExpandableSection>
  ) : null
}
